<template>
    <div class="mt-3 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12">
        <h2 class="w-full col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900">
            Attachments
            <file-upload class="float-right"
                name="attachments"
                ref="attachments"
                :folder="folder"
                :selectedFolder="selectedFolder ? selectedFolder.slug : null"
                :multiple="true"
                @uploaded="uploaded"
                :model="model"
                :id="id" />
            <button class="float-right bg-default-500 text-white text-xs py-1 px-3 mr-2" @click="showCreateFolderModal = true;">
                <font-awesome-icon class="text-white text-sm mr-2" :icon="['fal', 'folder-plus']" /> New Folder
            </button>
            <button class="float-right bg-default-500 text-white text-xs py-1 px-3 mr-2" @click="showEmailModal = true;" v-if="checkboxAttachments.length > 0">
                <font-awesome-icon class="text-white text-sm mr-2" :icon="['fal', 'paper-plane']" /> Email {{ checkboxAttachments.length }} <span v-if="checkboxAttachments.length === 1">Attachment</span><span v-else>Attachments</span>
            </button>
        </h2>
        <div class="w-full col-span-12">
            <table class="w-full">
                <thead>
                    <tr>
                        <th class="table-head-cell w-8">&nbsp;</th>
                        <th class="table-head-cell w-8">&nbsp;</th>
                        <th class="table-head-cell">&nbsp;</th>
                        <th class="table-head-cell text-left">Label</th>
                        <th class="table-head-cell text-center">Size</th>
                        <th class="table-head-cell">Uploaded By</th>
                        <th class="table-head-cell">Date Uploaded</th>
                        <th class="table-head-cell">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="!selectedFolder">
                        <tr v-for="(folder, rootFolderIndex) in selectedFolders" :key="rootFolderIndex">
                            <td class="table-body-cell" :class="[ rowOdd(rootFolderIndex) ? 'even' : 'odd' ]">&nbsp;</td>
                            <td class="table-body-cell text-center p-0 m-0" :class="[ rowOdd(rootFolderIndex) ? 'even' : 'odd' ]">
                                <font-awesome-icon class="text-black cursor-pointer text-lg text-yellow-600" :icon="['fas', 'folder']" @click="selectFolder(folder)"/>
                            </td>
                            <td class="table-body-cell py-3" :class="[ rowOdd(rootFolderIndex) ? 'even' : 'odd' ]">
                                <a href="javascript:void(0)" @click="selectFolder(folder)">{{ folder.name }}</a>
                            </td>
                            <td class="table-body-cell" :class="[ rowOdd(rootFolderIndex) ? 'even' : 'odd' ]" colspan="5">
                                &nbsp;
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td class="table-body-cell" :class="[ rowOdd(0) ? 'even' : 'odd' ]">&nbsp;</td>
                            <td class="table-body-cell text-center p-0 m-0" :class="[ rowOdd(0) ? 'even' : 'odd' ]">
                                <font-awesome-icon class="text-black cursor-pointer text-lg text-yellow-600" :icon="['fas', 'level-up-alt']" @click="goBack()"/>
                            </td>
                            <td class="table-body-cell py-3" :class="[ rowOdd(0) ? 'even' : 'odd' ]" @click="goBack()">
                                <a href="javascript:void(0)">. . {{ selectedFolder.parent ? 'Back to '+selectedFolder.parent.name : 'Back to Root' }}</a>
                            </td>
                            <td class="table-body-cell" :class="[ rowOdd(0) ? 'even' : 'odd' ]" colspan="5">
                                &nbsp;
                            </td>
                        </tr>
                        <tr v-for="(folder, folderIndex) in selectedFolder.children" :key="folderIndex">
                            <td class="table-body-cell" :class="[ rowOdd(folderIndex) ? 'even' : 'odd' ]">&nbsp;</td>
                            <td class="table-body-cell text-center p-0 m-0" :class="[ rowOdd(folderIndex) ? 'even' : 'odd' ]">
                                <font-awesome-icon class="text-black cursor-pointer text-lg text-yellow-600" :icon="['fas', 'folder']" @click="selectFolder(folder)"/>
                            </td>
                            <td class="table-body-cell py-3" :class="[ rowOdd(folderIndex) ? 'even' : 'odd' ]" @click="selectFolder(folder)">
                                <a href="javascript:void(0)">{{ folder.name }}</a>
                            </td>
                            <td class="table-body-cell" :class="[ rowOdd(folderIndex) ? 'even' : 'odd' ]" colspan="5">
                                &nbsp;
                            </td>
                        </tr>
                    </template>
                    <tr v-for="(attachment, index) in selectedAttachments" :key="index">
                        <td class="table-body-cell" :class="[ rowOdd(index) ? 'even' : 'odd' ]">
                            <input type="checkbox" v-model="checkboxAttachments" :value="attachment" class="w-4 h-4 form-checkbox text-default-500 rounded-none outline-none focus:outline-none focus:shadow-none cursor-pointer">
                        </td>
                        <td class="table-body-cell text-center p-0 m-0" :class="[ rowOdd(index) ? 'even' : 'odd' ]">
                            <font-awesome-icon v-if="attachment" class="text-black cursor-pointer text-lg" :class="FontAwesomeIcon(attachment.mime).class" :icon="[FontAwesomeIcon(attachment.mime).style, FontAwesomeIcon(attachment.mime).icon]"/>
                        </td>
                        <td class="table-body-cell" :class="[ rowOdd(index) ? 'even' : 'odd' ]">
                            <span @click="pushAttachment(attachment)" class="cursor-pointer">{{ attachment.filename ? attachment.filename : '' }}</span>
                        </td>
                        <td class="table-body-cell text-left" :class="[ rowOdd(index) ? 'even' : 'odd' ]">
                            <span v-if="!attachment.edit" class="mr-2">{{ attachment.name ? attachment.name : '' }}</span>
                            <input type="text" v-model="attachment.name" class="outline-none border border-gray-400 text-xs py-1 px-2 mr-2 w-3/4" v-if="attachment.edit"/>
                            <font-awesome-icon class="text-base outline-none text-gray-700 cursor-pointer" v-if="attachment.edit" @click="saveLabel(attachment)" :icon="['fas', 'save']" />
                            <font-awesome-icon class="text-base outline-none text-gray-700 cursor-pointer ml-2 mr-2" v-if="attachment.edit" @click="attachment.edit = false" :icon="['fas', 'times']" />
                            <font-awesome-icon class="text-sm outline-none text-gray-700 cursor-pointer" v-if="!attachment.edit" @click="attachment.edit = true" :icon="['fas', 'pencil-alt']" />
                        </td>
                        <td class="table-body-cell text-center" :class="[ rowOdd(index) ? 'even' : 'odd' ]">{{ attachment.size ? attachment.size : '' }}</td>
                        <td class="table-body-cell" :class="[ rowOdd(index) ? 'even' : 'odd' ]">{{ attachment.created_by ? attachment.created_by.full_name : '' }}</td>
                        <td class="table-body-cell" :class="[ rowOdd(index) ? 'even' : 'odd' ]">{{ new Date(attachment.created_at) | moment("DD/MM/YYYY h:mm a") }}</td>
                        <td class="table-body-cell" :class="[ rowOdd(index) ? 'even' : 'odd' ]">
                            <span class="flex flex-row">
                                <button type="button" @click="preview(S3URL+'/'+attachment.path, attachment.filename)" v-if="attachment.mime.includes('image')" v-tooltip="'Preview'" class="flex items-center justify-center px-2 py-2 cursor-pointer outline-none">
                                    <font-awesome-icon class="text-sm outline-none text-gray-700" :icon="['fas', 'eye']" />
                                </button>
                                <button type="button" @click="forceDownload(S3URL+'/'+attachment.path, attachment.filename)" v-tooltip="'Download'" class="flex items-center justify-center px-2 py-2 cursor-pointer outline-none">
                                    <font-awesome-icon class="text-sm outline-none text-gray-700" :icon="['fas', 'download']" />
                                </button>
                                <button type="button" @click="moveFolder(attachment)" v-tooltip="'Move'" class="flex items-center justify-center px-2 py-2 cursor-pointer outline-none">
                                    <font-awesome-icon class="text-sm outline-none text-gray-700" :icon="['fas', 'arrow-alt-circle-right']" />
                                </button>
                                <button type="button" class="flex items-center justify-center px-2 py-2 cursor-pointer outline-none" v-tooltip="'Delete'" @click="showDeleteModal = true">
                                    <font-awesome-icon class="text-sm outline-none text-gray-700" :icon="['fas', 'trash-alt']" />
                                </button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;" v-if="showCreateFolderModal">
            <div class="fixed inset-0 transition-opacity" @click="closeModal">
                <div class="absolute inset-0 bg-black opacity-75"></div>
            </div>
            <div class="bg-white overflow-hidden shadow-xl transform transition-all sm:max-w-2xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
                    <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                        <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="closeModal">
                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div class="sm:flex sm:items-start border-b border-gray-400">
                        <div class="mt-3 text-center sm:mt-0 sm:text-left">
                            <h3 class="text-lg leading-6 font-medium text-black pb-2" id="new-folder-modal-headline">
                                <slot name="heading">New Folder</slot>
                            </h3>
                        </div>
                    </div>
                    <div class="flex md:flex-col">
                        <div class="w-full mt-2 grid grid-cols-1 row-gap-1 col-gap-4 sm:grid-cols-12">
                            <input-text v-model="newFolderName" class="col-span-12" placeholder="New Folder Name"></input-text>
                        </div>
                        <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full mt-2" role="alert" v-if="newFolderError" >There was an error saving the new folder.</div>
                    </div>
                </div>
                <div class="bg-gray-200 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="saveFolder">
                        Save
                    </button>
                 </span>
                    <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="closeModal">
                    Cancel
                    </button>
                </span>
                </div>
            </div>
        </div>
        <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;" v-if="showMoveFolderModal">
            <div class="fixed inset-0 transition-opacity" @click="closeModal">
                <div class="absolute inset-0 bg-black opacity-75"></div>
            </div>
            <div class="bg-white overflow-hidden shadow-xl transform transition-all sm:max-w-2xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
                    <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                        <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="closeModal">
                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div class="sm:flex sm:items-start border-b border-gray-400">
                        <div class="mt-3 text-center sm:mt-0 sm:text-left">
                            <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
                                <slot name="heading">Move To</slot>
                            </h3>
                        </div>
                    </div>
                    <div class="flex md:flex-col">
                        <div class="w-full mt-2 grid grid-cols-1 row-gap-1 col-gap-4 sm:grid-cols-12">
                            <ul class="w-full text-sm col-span-12">
                                <li v-for="(folder, index) in thisFolders" :key="index" class="flex flex-col">
                                    <div class="flex flex-row items-center cursor-pointer pb-1" @click="selectedMoveFolder = folder">
                                        <span class="inline-block w-4 h-4 border border-gray-400 mr-2" :class="[ selectedMoveFolder && selectedMoveFolder.slug === folder.slug ? 'bg-default-500' : 'bg-gray-200' ]">&nbsp;</span>
                                        <span class="flex-grow">{{ folder.name }}</span>
                                    </div>

                                    <uL class="w-full ml-6" v-if="folder.children">
                                        <li v-for="(l2folder, l2index) in folder.children" :key="l2index" class="flex flex-col">
                                            <div class="flex flex-row items-center cursor-pointer pb-1" @click="selectedMoveFolder = l2folder">
                                                <span class="inline-block w-4 h-4 border border-gray-400 mr-2" :class="[ selectedMoveFolder && selectedMoveFolder.slug === l2folder.slug ? 'bg-default-500' : 'bg-gray-200' ]">&nbsp;</span>
                                                <span class="flex-grow">{{ l2folder.name }}</span>
                                            </div>

                                            <uL class="w-full ml-4" v-if="l2folder.children">
                                                <li v-for="(l3folder, l3index) in l2folder.children" :key="l3index" class="flex flex-col">
                                                    <div class="flex flex-row items-center cursor-pointer pb-1" @click="selectedMoveFolder = l3folder">
                                                        <span class="inline-block w-4 h-4 border border-gray-400 mr-2" :class="[ selectedMoveFolder && selectedMoveFolder.slug === l3folder.slug ? 'bg-default-500' : 'bg-gray-200' ]">&nbsp;</span>
                                                        <span class="flex-grow">{{ l3folder.name }}</span>
                                                    </div>
                                                </li>
                                            </uL>
                                        </li>
                                    </uL>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-200 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        :class="{'cursor-not-allowed opacity-50' : !selectedAttachment || !selectedMoveFolder }"
                        @click="moveToFolder"
                        :disabled="!selectedAttachment || !selectedMoveFolder">
                        Move Here
                    </button>
                 </span>
                    <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="closeModal">
                    Cancel
                    </button>
                </span>
                </div>
            </div>
        </div>
        <div class="fixed top-0 bottom-0 left-0 right-0 z-999 flex items-center justify-center" v-if="showPreview && previewURL">
            <div class="bg-black fixed top-0 bottom-0 left-0 right-0 opacity-75"></div>
            <div class="z-9999 max-h-screen max-w-screen-xl relative">
                <img :src="previewURL" alt="">
                <button class="absolute top-0 right-0 -mt-4 -mr-2 cursor-pointer" @click="showPreview = false; previewURL = null;">
                    <font-awesome-icon class="text-3xl outline-none text-white" :icon="['fas', 'times']" />
                </button>
            </div>
        </div>

        <email-modal v-if="showEmailModal"
            :to="{ email: item.customer.email, name: item.customer.first+' '+item.customer.last, locked: false }"
            @close="showEmailModal = false;"
            @sent="emailSent"
            :model="model"
            :id="id"
            :initial-attachments="checkboxAttachments"
        >
            <template v-slot:heading>Send Attachments</template>
        </email-modal>
    </div>
</template>

<script>
import axios from 'axios';
import EmailModal from "@/components/modals/EmailModal";

export default {
    name: "Attachments",
    props: {
        attachments: { type: Array, default: () => [], required: false },
        folders: { type: Array, default: () => [], required: false },
        model: { type: String, required: true },
        id: { required: true },
        folder: { type: String, required: true },
        item: { type: Object, required: false }
    },
    components: {
        EmailModal
    },
    data: function () {
        return {
            thisAttachments: [],
            thisFolders: [],
            selectedFolder: null,
            showDeleteModal: false,
            newFolderName: '',
            newFolderError: false,
            showCreateFolderModal: false,
            S3URL: process.env.VUE_APP_S3_URL,
            previewURL: null,
            showPreview: false,
            selectedAttachment: null,
            showMoveFolderModal: false,
            selectedMoveFolder: null,
            checkboxAttachments: [],
            showEmailModal: false
        }
    },
    mounted() {
        this.thisAttachments = this.attachments;
        this.thisFolders = this.folders;
    },
    methods: {
        pushAttachment: function(attachment){
            const index = this.checkboxAttachments.find(a => a.id === attachment.id);

            if (!index){
                this.checkboxAttachments.push(attachment);
            } else {
                this.checkboxAttachments.splice(index, 1)
            }
        },
        emailSent: function(){
            this.checkboxAttachments = [];
            this.showEmailModal = false;
        },
        moveToFolder: function(){
            this.$store.commit('TOGGLE_BACKDROP', {open: true});

            axios.put(process.env.VUE_APP_API_URL + '/attachments/'+this.selectedAttachment.id, {
                folder: this.selectedMoveFolder.slug
            }).then(response => {
                if (response.data.success){
                    this.selectedAttachment.folder = this.selectedMoveFolder.slug;
                    this.selectedMoveFolder = null;
                    this.selectedAttachment = null;
                    this.showMoveFolderModal = false;

                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'success',
                        title: 'Success',
                        text: response.data.message,
                        duration: 5000
                    });
                } else {
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: response.data.message,
                        duration: 5000
                    });
                }
                this.$store.commit('TOGGLE_BACKDROP', {open: false});
            }).catch(error => {
                this.$store.commit('TOGGLE_BACKDROP', {open: false});
            });
        },
        moveFolder: function(attachment){
            this.selectedAttachment = attachment;
            this.showMoveFolderModal = true;
        },
        saveLabel: function(attachment){
            this.$store.commit('TOGGLE_BACKDROP', {open: true});

            axios.put(process.env.VUE_APP_API_URL + '/attachments/'+attachment.id, {
                name: attachment.name
            }).then(response => {
                if (response.data.success){
                    attachment.edit = false;

                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'success',
                        title: 'Success',
                        text: response.data.message,
                        duration: 5000
                    });
                } else {
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: response.data.message,
                        duration: 5000
                    });
                }
                this.$store.commit('TOGGLE_BACKDROP', {open: false});
            }).catch(error => {
                this.$store.commit('TOGGLE_BACKDROP', {open: false});
            });
        },
        preview: function(url){
            let img = new Image();
            img.src = url;

            img.onload = () => {
                this.previewURL = url;
                this.showPreview = true;
            }
        },
        closeModal: function(){
            this.showCreateFolderModal = false;
            this.showMoveFolderModal = false;
            this.selectedAttachment = null;
            this.newFolderName = '';
            this.newFolderError = false;
        },
        goBack: function(){
            if (this.selectedFolder.parent){
                this.selectedFolder = this.thisFolders.filter(folder => {
                    return folder.slug === this.selectedFolder.parent.slug;
                })[0];
            } else {
                this.selectedFolder = null;
            }
        },
        saveFolder: function(){
            this.$store.commit('TOGGLE_BACKDROP', {open: true});
            const copyOfThisFolders = this.thisFolders.slice();

            if (!this.selectedFolder){
                this.thisFolders.push({
                    name: this.newFolderName,
                    slug: this.slugify(this.newFolderName),
                    parent: null
                });
            } else {
                if (!this.selectedFolder.children){
                    this.selectedFolder['children'] = [];
                }

                this.selectedFolder.children.push({
                    name: this.newFolderName,
                    slug: this.slugify(this.newFolderName),
                    parent: {
                        name: this.selectedFolder.name,
                        slug: this.selectedFolder.slug
                    }
                });
            }

            if (this.model && this.id) {
                axios.post(process.env.VUE_APP_API_URL + '/attachments/folders', {
                    model: this.model,
                    id: this.id,
                    folders: this.thisFolders
                }).then(response => {
                    if (response.data.success){
                        this.newFolderName = '';
                        this.showCreateFolderModal = false;
                        this.$emit('foldersUpdated', this.thisFolders);
                    } else {
                        this.thisFolders = copyOfThisFolders;
                        this.newFolderError = true;
                    }
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});
                }).catch(error => {
                    this.thisFolders = copyOfThisFolders;
                    this.newFolderError = true;
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});
                });
            } else {
                this.newFolderName = '';
                this.showCreateFolderModal = false;
                this.$emit('foldersUpdated', this.thisFolders);
            }
        },
        selectFolder: function(folder){
            this.selectedFolder = folder;
        },
        uploaded: function(payload){
            if(payload.success){
                payload.data.forEach(attachment => {
                    this.thisAttachments.push(attachment)
                });
            }
        },
        rowOdd: function(index){
            return index % 2 !== 0;
        },
        forceDownload: function(url, fileName){
            const xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = function(){
                const urlCreator = window.URL || window.webkitURL;
                const imageUrl = urlCreator.createObjectURL(this.response);
                const tag = document.createElement('a');
                tag.href = imageUrl;
                tag.download = fileName;
                document.body.appendChild(tag);
                tag.click();
                document.body.removeChild(tag);
            }
            xhr.send();
        },
        FontAwesomeIcon: function(mime_type){
            // console.log(mime_type)
            const font_awesome_file_icon_classes = {
                'image':                                                                        { icon: 'file-image', style: 'fas' },
                'image/vnd.adobe.photoshop':                                                    { icon: 'adobe', style: 'fab', class: 'text-red-600' },
                'audio':                                                                        { icon: 'file-audio', style: 'fas' },
                'video':                                                                        { icon: 'file-video', style: 'fas' },
                'application/pdf':                                                              { icon: 'file-pdf', style: 'fas', class: 'text-red-600' },
                'application/msword':                                                           { icon: 'file-word', style: 'fas', class: 'text-blue-600' },
                'application/vnd.ms-word':                                                      { icon: 'file-word', style: 'fas', class: 'text-blue-600' },
                'application/vnd.oasis.opendocument.text':                                      { icon: 'file-word', style: 'fas', class: 'text-blue-600' },
                'application/vnd.openxmlformats-officedocument.wordprocessingml':               { icon: 'file-word', style: 'fas', class: 'text-blue-600' },
                'application/vnd.ms-excel':                                                     { icon: 'file-excel', style: 'fas', class: 'text-green-600' },
                'application/vnd.openxmlformats-officedocument.spreadsheetml':                  { icon: 'file-excel', style: 'fas', class: 'text-green-600' },
                'application/vnd.oasis.opendocument.spreadsheet':                               { icon: 'file-excel', style: 'fas', class: 'text-green-600' },
                'application/vnd.ms-powerpoint':                                                { icon: 'file-powerpoint', style: 'fas', class: 'text-red-600' },
                'application/vnd.openxmlformats-officedocument.presentationml':                 { icon: 'file-powerpoint', style: 'fas', class: 'text-red-600' },
                'application/vnd.oasis.opendocument.presentation':                              { icon: 'file-powerpoint', style: 'fas', class: 'text-red-600' },
                'text/plain':                                                                   { icon: 'file-alt', style: 'fas' },
                'text/html':                                                                    { icon: 'file-code', style: 'fas' },
                'application/json':                                                             { icon: 'file-code', style: 'fas' },
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document':      { icon: 'file-word', style: 'fas', class: 'text-blue-600' },
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':            { icon: 'file-excel', style: 'fas', class: 'text-green-600' },
                'application/vnd.openxmlformats-officedocument.presentationml.presentation':    { icon: 'file-powerpoint', style: 'fas', class: 'text-red-600' },
                'application/gzip':                                                             { icon: 'file-archive', style: 'fas', class: 'text-yellow-500' },
                'application/zip':                                                              { icon: 'file-archive', style: 'fas', class: 'text-yellow-500' },
                'application/x-zip-compressed':                                                 { icon: 'file-archive', style: 'fas', class: 'text-yellow-500' },
                'application/octet-stream':                                                     { icon: 'file-archive', style: 'fas', class: 'text-yellow-500' },
            };

            if (font_awesome_file_icon_classes[mime_type]){
                return font_awesome_file_icon_classes[mime_type];
            }

            if (mime_type) {
                let mime_group = mime_type.split('/', 2)[0]
                return font_awesome_file_icon_classes[mime_group] ? font_awesome_file_icon_classes[mime_group] : { icon: 'file', style: 'fas' };
            } else {
                return { icon: 'file', style: 'fas' }
            }
        },
        slugify: function(string) {
            const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
            const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
            const p = new RegExp(a.split('').join('|'), 'g')

            return string.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text
        }
    },
    computed: {
        selectedAttachments() {
            if (!this.selectedFolder) {
                return this.thisAttachments.filter(attachment => !attachment.folder);
            } else {
                return this.thisAttachments.filter(attachment => attachment.folder === this.selectedFolder.slug);
            }
        },
        selectedFolders() {
            let folders = [];

            if (this.selectedFolder) {
                folders = this.selectedFolder.children;
            } else {
                folders = this.thisFolders;
            }

            return folders.sort(function(a, b){
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
            });
        },
    }
}
</script>

<style scoped>

</style>
